<p-fluid>
  <p-autoComplete [(ngModel)]="selectedCommunity" #communitySelection="ngModel" name="communitySelection"
    optionLabel="displayText" dataKey="orgId" [suggestions]="communitySuggestions" (completeMethod)="onComplete($event)" size="30"
    emptyMessage="No Active Communities in Market" [dropdown]="true" [forceSelection]="forceSelection()"
    [placeholder]="placeholder" (onSelect)="onChange()" (onClear)="clearCommunity()" [disabled]="disabled"
    [required]="required()" />
  <error-message [errorControl]="communitySelection">
    @if (communitySelection?.errors?.required) {
      <span>Please select at least one community to continue.</span>
    }
  </error-message>
</p-fluid>